import React from "react";
import { Helmet } from "react-helmet";

const BreadcrumbSchema = () => {
  const breadcrumbSchema = {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.aihairstylestudio.com/" },
      { "@type": "ListItem", "position": 2, "name": "Studio Hair Salon", "item": "https://www.aihairstylestudio.com/studio-hair-salon" },
      { "@type": "ListItem", "position": 3, "name": "Terms of Service", "item": "https://www.aihairstylestudio.com/legal/terms" },
      { "@type": "ListItem", "position": 4, "name": "Contact", "item": "https://www.aihairstylestudio.com/contact" },
      { "@type": "ListItem", "position": 5, "name": "Blog", "item": "https://www.aihairstylestudio.com/blog" },
      { "@type": "ListItem", "position": 6, "name": "Privacy Policy", "item": "https://www.aihairstylestudio.com/legal/privacy" },
      { "@type": "ListItem", "position": 7, "name": "Dashboard", "item": "https://www.aihairstylestudio.com/dashboard" },
      { "@type": "ListItem", "position": 8, "name": "Try On Hairstyles", "item": "https://www.aihairstylestudio.com/try-on" }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
    </Helmet>
  );
};

export default BreadcrumbSchema;
